/**
 * Remove trailing M-Pesa / Safaricom-style masked phone (e.g. "James Maina 0727***024").
 */
export function stripMaskedPhoneSuffix(value = "") {
  let s = String(value || "").trim();
  if (!s) return "";
  // e.g. " 0727***024", " 0712****56"
  s = s.replace(/\s+0\d{2,4}\*{2,}\d*\s*$/i, "");
  // e.g. " +254***123", " 254****789012"
  s = s.replace(/\s+\+?254\*{2,}\d*\s*$/i, "");
  s = s.replace(/\s+\+?254\d\*{2,}\d*\s*$/i, "");
  // Whole string is only a masked number (no name)
  s = s.replace(/^0\d{2,4}\*{2,}\d*$/i, "");
  s = s.replace(/^\+?254\*{2,}\d*$/i, "");
  return s.trim();
}

/**
 * Title-case a person name for display (words by spaces; hyphenated parts per word).
 */
export function formatPersonName(name) {
  const raw = String(name ?? "").trim();
  if (!raw) return "";
  return raw
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split("-")
        .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part))
        .join("-")
    )
    .join(" ");
}
